/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_ButtonInputs */



/**
* | output |
* | --- |
* | "Fix" |
*
* @param {Qc_Fix_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_button = /** @type {((inputs?: Qc_Fix_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir")
	return /** @type {LocalizedString} */ ("Fix")
});